/*jshint -W061 */

(function () {
    'use strict';

    angular
        .module("skillsApp")
        .directive("fileInput", fileInput);

    function fileInput() {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                var fn = eval('scope.' + attrs.fileInput);
                elem.on('change', function (e) {
                    scope.$apply(function () {
                        fn(elem[0].files);
                    });
                });
            }
        };
    }
})();